'use client';

import { ThemeToggle } from '@/components/ThemeToggle';
import { useTheme } from 'next-themes';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

export default function Home() {
  const { resolvedTheme } = useTheme();
  const [src, setSrc] = useState('/images/exacto-health-logo-light.svg');

  useEffect(() => {
    setSrc(
      resolvedTheme === 'dark'
        ? '/images/exacto-health-logo-dark.svg'
        : '/images/exacto-health-logo-light.svg',
    );
  }, [resolvedTheme]);

  return (
    <div className="font-sans grid grid-rows-[auto_1fr_auto] min-h-screen items-center justify-items-center px-4 sm:px-8 transition-colors">
      <main className="flex flex-col gap-6 items-center text-center max-w-lg w-full py-12 z-10">
        <div className="relative items-center justify-center h-32 w-32">
          <Image src={src} alt="AuditMED" fill priority />
        </div>

        <h1 className="text-3xl font-bold tracking-tight">Bienvenido</h1>

        <p className="text-base">
          Plataforma de auditoría documental, técnica y de liquidación para
          prestadores de salud en Ecuador.
        </p>
        <div className="flex items-center gap-2">
          <ThemeToggle collapsed={false} showContent={true} />
        </div>

        <Link
          href="/auth/login"
          className="text-primary-foreground font-semibold px-5 py-2.5 rounded-lg bg-primary hover:bg-primary/90 transition duration-200 shadow-md"
        >
          Iniciar sesión
        </Link>
      </main>

      <footer className="text-xs sm:text-sm text-zinc-600 py-6 z-10">
        &copy; {new Date().getFullYear()} AuditMED. Todos los derechos
        reservados.
      </footer>
    </div>
  );
}
